(function () {
  'use strict';
  if (window.__cityConverterEntryAnalyticsBound) return;
  window.__cityConverterEntryAnalyticsBound = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-converter-entry]');
    if (!link) return;
    var detail = {
      event: 'converter_entry_click',
      converter_entry_source: link.dataset.converterEntrySource || 'unknown',
      converter_entry_intent: link.dataset.converterEntryIntent || 'unknown',
      converter_mode: link.dataset.converterMode || 'glasses',
      converter_goal: link.dataset.converterGoal || 'generic'
    };
    if (link.dataset.converterPdpType) detail.converter_pdp_type = link.dataset.converterPdpType;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(detail);
  });
})();
